import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import localStorageService from "@/core/services/localStorage.service";
import { assign } from "lodash";

import { responseError } from '@/core/mixin/shared';

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const FORGOT_PASSWORD = "forgotPassword";
export const RESET_PASSWORD = "resetPassword";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";

const LOGIN_URL = "api/token";
const FORGOT_PASSWORD_URL = "api/forgot-password";
const RESET_PASSWORD_URL = "api/reset-password";

const state = {
  errors: null,
  user: {},
  menu: {},
  data: {},
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  currentMenu(state) {
    return state.menu;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      credentials = assign({}, credentials, { grant_type: "password" });
      ApiService.post(LOGIN_URL, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
        });
    });
  },
  [FORGOT_PASSWORD](context, credentials) {
    return new Promise(resolve => {
      ApiService.post(FORGOT_PASSWORD_URL, credentials)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
        });
    });
  },
  [RESET_PASSWORD](context, credentials) {
    return new Promise(resolve => {
      ApiService.post(RESET_PASSWORD_URL, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [VERIFY_AUTH](context) {
    if (!JwtService.getToken()) {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, password) {
    return ApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = responseError(error);
  },
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.user = data;
    state.errors = null;
    state.token = data;
    JwtService.saveToken(state.user.access_token);
    localStorageService.setItem("token", state.user.access_token);
    localStorageService.setItem("refresh_token", state.user.refresh_token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = null;
    state.data = {};
    state.errors = null;
    JwtService.destroyToken();
    localStorageService.destroyStorage();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
